import { AlertCircle, AlertTriangle, CheckCircle2 } from 'lucide-react';
import type { LegalityReport } from '@/lib/deck-utils';

export function LegalityPanel({ report }: { report: LegalityReport }) {
  const errors = report.issues.filter(i => i.severity === 'error');
  const warnings = report.issues.filter(i => i.severity === 'warning');

  if (errors.length === 0 && warnings.length === 0) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-ink-emerald/30 bg-ink-emerald/5 p-3 mb-3 animate-fade-in">
        <CheckCircle2 className="h-4 w-4 text-ink-emerald flex-shrink-0" />
        <span className="text-xs font-medium text-ink-emerald font-body">Tournament-legal · 60 cards · {report.inkableCount} inkable</span>
      </div>
    );
  }

  return (
    <div className={`rounded-xl border p-3 mb-3 animate-fade-in ${errors.length ? 'border-ink-ruby/30 bg-ink-ruby/5' : 'border-primary/30 bg-primary/5'}`}>
      <div className="flex items-center gap-2 mb-2">
        {errors.length ? (
          <AlertCircle className="h-4 w-4 text-ink-ruby flex-shrink-0" />
        ) : (
          <AlertTriangle className="h-4 w-4 text-primary flex-shrink-0" />
        )}
        <span className={`text-xs font-medium font-body ${errors.length ? 'text-ink-ruby' : 'text-primary'}`}>
          {errors.length ? `${errors.length} issue${errors.length === 1 ? '' : 's'} to fix` : `${warnings.length} suggestion${warnings.length === 1 ? '' : 's'}`}
        </span>
      </div>
      <ul className="space-y-1">
        {errors.map((iss, i) => (
          <li key={`e${i}`} className="flex items-start gap-1.5 text-[11px] text-ink-ruby font-body">
            <span className="text-ink-ruby">•</span><span>{iss.message}</span>
          </li>
        ))}
        {warnings.map((iss, i) => (
          <li key={`w${i}`} className="flex items-start gap-1.5 text-[11px] text-muted-foreground font-body">
            <span className="text-primary">•</span><span>{iss.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
